var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("div", { staticClass: "row align-items-center" }, [
      _c("div", { staticClass: "col-lg col-6" }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("direct-to-lender.lenderSubmit.principalBorrower")
              ) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _vm.principalBorrower
          ? _c("p", [
              _vm._v("\n        " + _vm._s(_vm.principalBorrower) + "\n      "),
            ])
          : _c("p", [_vm._v(" ")]),
      ]),
      _vm._v(" "),
      _vm.readOnly
        ? _c("div", { staticClass: "col-lg col-6" }, [
            _c("h6", { staticClass: "form-title font-sm" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("direct-to-lender.lenderSubmit.applicationType")
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.dealTypeLabel
              ? _c("p", [
                  _vm._v("\n        " + _vm._s(_vm.dealTypeLabel) + "\n      "),
                ])
              : _c("p", [_vm._v(" ")]),
          ])
        : _c(
            "div",
            { staticClass: "col-lg col-6 form-container" },
            [
              _c(
                "h6",
                { staticClass: "form-title font-sm mb-0" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("direct-to-lender.lenderSubmit.applicationType")
                      ) +
                      "\n        "
                  ),
                  _c("input-required-indicator"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "material-input",
                {
                  staticClass: "w-lg-50 w-100 pb-3",
                  attrs: { "no-label": "" },
                  model: {
                    value: _vm.dealType,
                    callback: function ($$v) {
                      _vm.dealType = $$v
                    },
                    expression: "dealType",
                  },
                },
                [
                  _c("v-select-field", {
                    staticClass: "simple-dd",
                    attrs: {
                      options: _vm.applicationTypeOptions,
                      disabled: _vm.readOnly,
                      placeholder: _vm.$t(
                        "direct-to-lender.lenderSubmit.applicationType"
                      ),
                      scenario: "simple",
                      label: "text",
                      "default-value": _vm.dealType,
                      name: "dealType",
                    },
                    on: {
                      "option:selected": function (val) {
                        _vm.dealType = val.id
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center" }, [
      _c("div", { staticClass: "col-lg col-6" }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("direct-to-lender.lenderSubmit.applicationStatus")
              ) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _vm.applicationStatusText
          ? _c("p", [
              _vm._v(
                "\n        " + _vm._s(_vm.applicationStatusText) + "\n      "
              ),
            ])
          : _c("p", [_vm._v(" ")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg col-6" }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("direct-to-lender.lenderSubmit.applicationPurpose")
              ) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _vm.applicationFlowText
          ? _c("p", [
              _vm._v(
                "\n        " + _vm._s(_vm.applicationFlowText) + "\n      "
              ),
            ])
          : _c("p", [_vm._v(" ")]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center" }, [
      _c("div", { staticClass: "col-lg col-6" }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("direct-to-lender.lenderSubmit.totalLoanAmount")) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _vm.totalLoanAmount
          ? _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("formatMoneyValueLong")(_vm.totalLoanAmount)) +
                  "\n      "
              ),
            ])
          : _c("p", [_vm._v(" ")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg col-6" }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("direct-to-lender.lenderSubmit.purchasePriceValue")
              ) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _vm.purchasePrice
          ? _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("formatMoneyValueLong")(_vm.purchasePrice)) +
                  " /\n        " +
                  _vm._s(_vm._f("formatMoneyValueLong")(_vm.propertyValue)) +
                  "\n      "
              ),
            ])
          : _c("p", [_vm._v(" ")]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center" }, [
      _c("div", { staticClass: "col-lg col-6" }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("global.doorr.closingDate")) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _vm.closingDate
          ? _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm._f("momentLocal")(_vm.closingDate, "MMM DD, yyyy")
                  ) +
                  "\n      "
              ),
            ])
          : _c("p", [_vm._v(" ")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }